// Firebase configuration
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA2KTpGKcWbwir_u2pTu-AaMRmhu4oJcmg",
  authDomain: "nepali-ballot-final.firebaseapp.com",
  projectId: "nepali-ballot-final",
  storageBucket: "nepali-ballot-final.firebasestorage.app",
  messagingSenderId: "957477431413",
  appId: "1:957477431413:web:cc16bdb162bdfc13d5f03c",
  measurementId: "G-KFSP6QFLCH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { app, analytics };
